import React from "react";
// UI Frameworks
import { Col, Row, Typography } from "antd";
// Shared components
import PageTitle from "components/PageTitle";
// Utilities and hooks
import cs from "classnames";
import { get } from "lodash";
import { AppStore } from "state/index";
import { observer, inject } from "mobx-react";
// Styles
import styles from "./index.module.scss";
// Assets
import Logo from "assets/images/baazar.png";

interface IProps {
	title?: string;
	subTitle?: string;
	children: React.ReactNode;
	appStore?: AppStore;
}

const { Title, Text, Paragraph } = Typography;

const Main: React.FC<IProps> = (props: IProps) => {
	return (
		<Row type="flex" className={styles["auth-wrapper"]}>
			<Col
				className={styles["auth-wrapper__auth-right"]}
				lg={{ span: 6, offset: 6, pull: 3 }}
				md={{ span: 10, offset: 2, pull: 8 }}
				xs={{ span: 20, offset: 2, pull: 2 }}
				sm={{ span: 10, offset: 2, pull: 8 }}
			>
				<div>
					<PageTitle title={props.title} />
					<div className={cs(styles["auth-wrapper__auth-header"], styles["auth-header"])}>
						<div className={styles["auth-wrapper__auth-header__logo"]}>
							<img src={Logo} alt="سامانه بازر" height="128" />
						</div>
						<Title level={4}>سامانه بازر</Title>
						{props.subTitle ? <h5>{props.subTitle}</h5> : null}
					</div>
					<div>{props.children}</div>
					<Paragraph type="secondary" className={styles["auth-wrapper__version"]}>
						v{process.env.APP_VERSION}
						{" - "}
						{get(props.appStore, ["version"])}
					</Paragraph>
				</div>
			</Col>
			<Col className={styles["auth-wrapper__auth-left"]} lg={12}>
				<Title level={3}>درباره ما</Title>
				<Text className={styles["auth-wrapper__about-us"]} strong>
					بازر اولین پلتفرم آنلاین عرضه پلاک طلا در ایران است که کاربران را قادر می سازد با هر مبلغی (حتی
					بسیار اندک) در بازار طلا سرمایه گذاری کنند و پس از رسیدن به وزن یک پلاک، اقدام به دریافت فیزیکی پلاک
					طلای خود نمایند. بازر با ترکیب تجربه و دانش متخصصان حوزه طلا و فناوری‌های دیجیتال توانسته است
					پلتفرمی ایمن، کارا و کاربرپسندی را ارائه دهد و خود را به عنوان پیشگام این حوزه در ایران معرفی نماید.
					بازر همواره خود را مقید می‌داند همگام با کاربران حرکت کرده و با شناسایی نیازهای آن‌ها، با جدیدترین
					فناوری‌های روز دنیا، تجربه منحصر به فردی را برای آن‌ها رقم بزند. رسالت بازر فراهم آوردن امکان سرمایه
					گذاری طلا برای همه اقشار جامعه در نقاط جغرافیای مختلف است. شما می‌توانید در هر ساعت از شبانه روز و
					در هر نقطه جغرافیایی از بازر، طلا را به قیمت روز خریده یا بفروشید و پول آن را دریافت نمایید. در
					صورتی که شما تمایل به دریافت حضوری ما‌به‌ازای طلای خود را دارید یا می‌خواهید حجم مشخصی از طلای
					خریداری‌شده خود را به صورت فیزیکی دریافت نمایید، می‌توانید با هماهنگی قبلی به آدرس ما مراجعه کنید.
				</Text>
				<br />
				<ul>
					<li>
						پشتیبانی: <span>از ساعت ۹ صبح تا ۱۸، شنبه تا چهارشنبه</span>
					</li>
					<li>
						شماره تماس:{" "}
						<span>
							<a href="tel:+982165013024">65013024-021</a>
						</span>
					</li>
				</ul>
			</Col>
		</Row>
	);
};
Main.defaultProps = {
	title: "سامانه بازر",
};

export default inject("appStore")(observer(Main));
